var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconInbound01 = function SvgIconInbound01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient);\n      }"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0,
    y1: 62.5,
    x2: 100,
    y2: 62.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 35.71,
    y1: 30.36,
    x2: 64.29,
    y2: 30.36,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g1219"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect1191",
    className: "cls-2",
    d: "M24.39,25c-5.37,0-10.26,3.18-12.44,8.08L.31,59.26c-.25.52-.31,1-.31,1.45v28.57c0,5.87,4.84,10.71,10.71,10.71h78.57c5.87,0,10.71-4.84,10.71-10.71v-28.57c0-.48-.09-.91-.31-1.45-3.88-8.72-7.76-17.45-11.64-26.18-2.18-4.91-7.07-8.08-12.44-8.08h-7.76c-1.97,0-3.57,1.6-3.57,3.57s1.6,3.57,3.57,3.57h7.76c2.57,0,4.87,1.5,5.92,3.84l9.4,21.16h-16.64c-3.57,0-6.83,2.11-8.29,5.36l-3.5,7.77c-.32.71-1,1.15-1.78,1.15h-21.43c-.78,0-1.46-.44-1.78-1.15l-3.5-7.77c-1.47-3.26-4.72-5.36-8.29-5.36H9.07l9.4-21.16c1.04-2.35,3.35-3.84,5.92-3.84h7.76c1.97,0,3.57-1.6,3.57-3.57s-1.6-3.57-3.57-3.57h-7.76ZM7.14,64.29h18.57c.78,0,1.46.44,1.78,1.15l3.5,7.77c1.47,3.26,4.72,5.36,8.29,5.36h21.43c3.57,0,6.83-2.11,8.29-5.36l3.5-7.77c.32-.71,1-1.15,1.78-1.15h18.57v25c0,2.04-1.53,3.57-3.57,3.57H10.71c-2.04,0-3.57-1.53-3.57-3.57v-25Z",
    vectorEffect: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1211",
    className: "cls-1",
    d: "M50,0C48.03,0,46.43,1.6,46.43,3.57v44.95l-4.62-4.62c-1.56-1.54-3.62-1.43-5.05,0-1.39,1.39-1.39,3.66,0,5.05l10.71,10.71c1.39,1.39,3.66,1.39,5.05,0l10.71-10.71c1.39-1.39,1.39-3.66,0-5.05-1.39-1.39-3.66-1.39-5.05,0l-4.62,4.62V3.57C53.57,1.6,51.97,0,50,0Z",
    vectorEffect: "none"
  }))));
};
export default SvgIconInbound01;